export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              移动观影
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              桃子视频完美适配手机和平板等移动设备。无论你在地铁上、咖啡馆里，还是窝在沙发上，打开手机浏览器就能随时随地畅享高清影视。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              无需下载安装任何 APP，在移动端同样可以享受流畅的 1080P 超清播放体验。自适应屏幕布局让操作更便捷，竖屏横屏随心切换，追剧观影从未如此轻松。
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-background-50 border border-background-200/60">
                <i className="ri-smartphone-line text-primary-500 text-xl"></i>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">手机浏览器</div>
                  <div className="text-xs text-foreground-500">直接访问即可观影</div>
                </div>
              </div>
              <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-background-50 border border-background-200/60">
                <i className="ri-tablet-line text-accent-500 text-xl"></i>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">平板电脑</div>
                  <div className="text-xs text-foreground-500">大屏沉浸体验</div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative">
              <div className="w-64 h-[480px] rounded-3xl overflow-hidden border-4 border-foreground-800 shadow-2xl bg-foreground-950">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20a%20modern%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%2C%20warm%20coral%20and%20dark%20theme%2C%20clean%20UI%20design%2C%20cinematic%20app%20screenshot%20style%2C%20no%20text&width=500&height=1000&seq=app-mobile-mock&orientation=portrait"
                  alt="桃子视频移动端界面预览"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -top-3 -right-3 w-12 h-12 rounded-full flex items-center justify-center bg-primary-500 text-white shadow-lg">
                <i className="ri-flashlight-line text-lg"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}